import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useUpdateLabel } from "@/domain/label/hooks/api/use-update-label";

type RemoveLabelFromGroupActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  label: {
    id: string;
    labelGroupId?: string | null;
  };
  workspace: {
    id: string;
  };
};

export const RemoveLabelFromGroupAction = ({ label, asChild, ...props }: RemoveLabelFromGroupActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { updateLabel } = useUpdateLabel({
    onCompleted: () => {
      toast.success(t("label.removeFromGroupSuccess"), { description: t("label.removeFromGroupSuccessDescription") });
    },
    onError: () => {
      toast.error(t("errors.title"), { description: t("label.removeFromGroupError") });
    },
  });

  async function handleClick() {
    await updateLabel({ id: label.id, labelGroupId: null });
  }

  return <Comp {...props} onClick={handleClick} />;
};
